// Mobile events
export enum MOBILE_ACTIONS {
  BACK = 1,
  DATA_LINK = 'DATA_LINK',
  DATA_URI = 'DATA_URI',
}

// Logging
export const PRODUCTION_DOMAIN = 'booking.cergea.com';

// User flow control
export enum BOOKING_MODE {
  CANCEL = 'CANCEL',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

// API communication
export const OAG_API_VERSION = 'v2';
export const TRAVEL_TYPE = 'DEPARTURE';
export const CODE_IATA = 'IATA';
export const CODE_ICAO = 'ICAO';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_POLL_INTERVAL = 1000;
export const DEFAULT_POLL_ATTEMPTS = 5;

// Meta data
export const SITE_NAME = 'Booking';

// Time formatting
export const TIME_FORMAT_DISPLAY = 'h:mma';
export const DATE_READABLE_FORMAT = 'ddd D MMMM YYYY';
export const DATE_TIME_FLIGHT_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const TIME_FORMAT = 'HH:mm';

export const DEFAULT_PARTNER_KEY = 'partnerIdProd';

// Payload
export const DEFAULT_LANGUAGE_CODE = 'en';
export const DEFAULT_PLATFORM = 'web';
export const DEFAULT_VERSION = '6.32.2';

export const PRE_AGREED_SUPPLIER_CODE = '000';
export const CAVU_SUPPLIER_CODE = '007';
